module.exports = __webpack_public_path__ + "static/img/bg_desktop.a8353486.webp";